import _extends from "@babel/runtime/helpers/extends";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import Spinner from '@atlaskit/spinner';
import EmojiPickerCategoryHeading from './EmojiPickerCategoryHeading';
import EmojiPickerEmojiRow from './EmojiPickerEmojiRow';
import { sizes } from './EmojiPickerSizes';
import { emojiPickerSpinner } from './styles';
export var AbstractItem = /*#__PURE__*/_createClass(function AbstractItem(props, height) {
  _classCallCheck(this, AbstractItem);
  this.props = props;
  this.height = height;
});
export var EmojisRowItem = /*#__PURE__*/function (_AbstractItem) {
  function EmojisRowItem(props) {
    var _this;
    _classCallCheck(this, EmojisRowItem);
    _this = _callSuper(this, EmojisRowItem, [props, sizes.emojiRowHeight]);
    _defineProperty(_this, "renderItem", function (context) {
      return jsx(EmojiPickerEmojiRow, _extends({}, _this.props, {
        virtualItemContext: context
      }));
    });
    return _this;
  }
  _inherits(EmojisRowItem, _AbstractItem);
  return _createClass(EmojisRowItem);
}(AbstractItem);
export var LoadingItem = /*#__PURE__*/function (_AbstractItem2) {
  function LoadingItem() {
    var _this2;
    _classCallCheck(this, LoadingItem);
    _this2 = _callSuper(this, LoadingItem, [{}, sizes.loadingRowHeight]);
    _defineProperty(_this2, "renderItem", function () {
      return (
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        jsx("div", {
          css: emojiPickerSpinner
        }, jsx("div", null, jsx(Spinner, {
          size: "medium",
          interactionName: "emoji-picker-loading-item-spinner"
        })))
      );
    });
    return _this2;
  }
  _inherits(LoadingItem, _AbstractItem2);
  return _createClass(LoadingItem);
}(AbstractItem);
export var CategoryHeadingItem = /*#__PURE__*/function (_AbstractItem3) {
  function CategoryHeadingItem(props) {
    var _this3;
    _classCallCheck(this, CategoryHeadingItem);
    _this3 = _callSuper(this, CategoryHeadingItem, [props, sizes.categoryHeadingHeight]);
    _defineProperty(_this3, "renderItem", function () {
      return jsx(EmojiPickerCategoryHeading, _this3.props);
    });
    return _this3;
  }
  _inherits(CategoryHeadingItem, _AbstractItem3);
  return _createClass(CategoryHeadingItem);
}(AbstractItem);
export var virtualItemRenderer = function virtualItemRenderer(rows, context) {
  var index = context.index,
    key = context.key;
  var row = rows[index];
  return jsx("div", {
    key: key
  }, row && row.renderItem(context));
};